import {Component, Input} from '@angular/core';
import {ModelID} from "../../../_typing/generic-types";
import {SeriesAuditStatistics} from "../series-audit-history.component";
import {SeriesAuditHistoryService} from "../series-audit-history.service";
import {BaseComponent} from "../../../shared/base.component";
import {takeUntil} from "rxjs/operators";
import {deepCopy} from "../../../lib/utils";
import {SharedPipesModule} from "../../../shared/modules/shared-pipes.module";



@Component({
    selector: 'series-audit-statistics',
    templateUrl: './series-audit-statistics.component.html',
    styleUrl: './series-audit-statistics.component.scss',
    imports: [
        SharedPipesModule
    ],
})
export class SeriesAuditStatisticsComponent extends BaseComponent {
    @Input() seriesId: ModelID;
    @Input() timestamp: string;
    seriesStatistics: SeriesAuditStatistics;
    loadingStatistics: boolean = false;

    constructor(
        private cps: SeriesAuditHistoryService) {
        super();
    }

    ngOnInit() {
        const start = new Date(this.timestamp);
        const end = (deepCopy(start)).addHours(1);
        const key = this.seriesId + this.cps.getTimestampKey(start);
        this.cps.$seriesStatistics.pipe(takeUntil(this.onDestroy))
            .subscribe((result: SeriesAuditStatistics) => {
                if (result?.id === key) {
                    this.seriesStatistics = result;
                }
                this.loadingStatistics = false;
            });


        this.loadingStatistics = true;
        this.cps.getSeriesTimeStatistics(this.seriesId, start, end);
    }
}
